// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorUpsearchModel {
    static getAttributeTypeMap() {
        return PayorUpsearchModel.attributeTypeMap;
    }
}
PayorUpsearchModel.discriminator = undefined;
PayorUpsearchModel.additionalProperties = false;
PayorUpsearchModel.attributeTypeMap = [
    {
        "name": "payorId",
        "baseName": "payorId",
        "type": "number"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<PayorSharedAddressUpsearchModel>"
    },
    {
        "name": "contacts",
        "baseName": "contacts",
        "type": "Array<PayorSharedContactUpsearchModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<PayorSharedEmailAddressUpsearchModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<PayorSharedPhoneUpsearchModel>"
    },
    {
        "name": "webAddresses",
        "baseName": "webAddresses",
        "type": "Array<PayorSharedWebAddressUpsearchModel>"
    },
    {
        "name": "payorName",
        "baseName": "payorName",
        "type": "string"
    },
    {
        "name": "payorType",
        "baseName": "payorType",
        "type": "PayorType"
    },
    {
        "name": "payorBin",
        "baseName": "payorBin",
        "type": "string"
    },
    {
        "name": "payorPcn",
        "baseName": "payorPcn",
        "type": "string"
    },
    {
        "name": "payorGroup",
        "baseName": "payorGroup",
        "type": "string"
    },
    {
        "name": "isPlaceholder",
        "baseName": "isPlaceholder",
        "type": "boolean"
    },
];
//# sourceMappingURL=payorUpsearchModel.js.map